<template>
  <header id="page-header" ref="headroom">
    <div id="page-header-inner">
      <div class="page-header-inner max-width side-padding">
        <Logo></Logo>
        
        <div class="menu-block right">
          <div class="social">
            <span>Seguici su </span>
            <a class="facebook" target="_blank" href="https://www.facebook.com/EdizioniCaramba/" rel="external noopener noreferrer" title="Facebook"><span class="underline">Facebook</span></a>
            <a class="youtube" target="_blank" href="https://www.youtube.com/user/EdizioniCaramba" rel="external noopener noreferrer" title="Youtube"><span class="underline">Youtube</span></a>
          </div>

          <nav id="main-nav" role="navigation">
            <ul>
              <li class="medium"><router-link to="/about">Chi Siamo</router-link></li>
              <li class="medium"><router-link to="/catalog">Catalogo</router-link></li>
              <li class="medium"><router-link to="/report">Programmazioni</router-link></li>
              <li class="medium"><router-link to="/contact">Contatti</router-link></li>
              <li class="medium">
                <router-link v-if="user && user.id" to="/user">Profilo</router-link>
                <router-link v-else to="/login">Accedi</router-link>
                
              </li>
            </ul>
          </nav>
        </div>

        <div id="hamburger" v-on:click="mobileToggle" ref="hamburger"><span></span><span></span><span></span></div>
      </div>
    </div>	
  </header>
</template>

<script>
import Logo from './Logo'
import Headroom from 'headroom.js';

export default {
  name: 'Header',

  props: ['user'],
  
  watch: {
    '$route' (to, from) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('main-nav-visible');
      this.$refs.hamburger.classList.remove('menu-open');
      
    }
  },
  
  components: {
    Logo
  },
  
  mounted() {
    const headroom = new Headroom(this.$refs.headroom, {offset: 40});
    headroom.init();
  },
  
  methods: {
    mobileToggle: function(e) {
      e.preventDefault();
      const body = document.getElementsByTagName('body')[0];

      if(e.target.classList.contains('menu-open')) {
        e.target.classList.remove('menu-open');
        body.classList.remove('main-nav-visible');
      } else {
        e.target.classList.add('menu-open');
        body.classList.add('main-nav-visible');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../css/variables.css';

.router-link-active {
  background: var(--light_purple);
}

@media (min-width: 769px) {
  #page-header.headroom--unpinned {
    transform: translate(-50%, -70px);
    height: 135px;
    overflow: hidden;
  }
}
</style>


// WEBPACK FOOTER //
// src/vue/components/Header.vue